import React from 'react';
import { useRestaurant } from '../context/RestaurantContext';
import { printCurrencySymbol, renderPrice } from '../helpers/_commonHelper';
import { useLanguage } from '../context/LanguageContext';
import Counter from './Counter';
import { Button, Drawer } from 'antd';

const CheckoutAddonRepeatConfirm = (props) => {
    const { open, close, item, removeItem, duplicateItem, addNewAddon } = props;
    const { restaurantDetails } = useRestaurant();
    const currentCurrency = printCurrencySymbol(restaurantDetails);
    const { t } = useLanguage();

    return (
        <Drawer
            title={t['choose_preference']}
            className='h-48'
            onClose={close}
            open={open}
            size={'default'}
            placement='bottom'
            height={'450px'}
        >
            <div
                className='flex flex-col justify-start gap-4 pb-16'
                aria-modal='true'
            >
                <div className='item-food-card'>
                    <div className='item-details-wrapper'>
                        <div className='item-title-wrapper'>
                            <div className='item-price'>
                                <div className='item-title'>
                                    {/* {item.type === 'veg' && (
                                            <div className='item-type'>
                                                <img src={veg} alt='veg_icon' />
                                            </div>
                                        )}
                                        {item.type === 'non_veg' && (
                                            <div className='item-type'>
                                                <img
                                                    src={nonveg}
                                                    alt='nonveg_icon'
                                                />
                                            </div>
                                        )}{' '} */}
                                    {item.itemName}
                                </div>
                                {item.itemPrice > 0 ? (
                                    <div className='item-price'>
                                        {currentCurrency}{' '}
                                        {renderPrice(
                                            item.itemPrice,
                                            restaurantDetails
                                        )}
                                    </div>
                                ) : (
                                    `  `
                                )}
                                {item.addons.length !== 0 ? (
                                    <ul className='selectedAddonList'>
                                        {item?.addons?.map((add) => {
                                            return (
                                                <li>
                                                    <span
                                                        className='addon-name-wrapper'
                                                        dangerouslySetInnerHTML={{
                                                            __html: `${add.title}: ${add.name}`,
                                                        }}
                                                    ></span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                ) : null}
                            </div>
                            <div className='item-actions'>
                                <Counter
                                    count={item.itemCount}
                                    increment={() => duplicateItem(item)}
                                    decrement={() => removeItem(item)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='flex justify-center items-center gap-2 mt-auto absolute bg-slate-100 p-2 py-3 w-full left-0 bottom-0'>
                <Button
                    className='bg-theme'
                    onClick={() => addNewAddon()}
                    type='primary'
                >
                    {t['add_new_customization']}
                </Button>
            </div>
        </Drawer>
    );
};

export default CheckoutAddonRepeatConfirm;
